import React from 'react';
import NumberFormatter from 'features/shared/components/formatters/NumberFormatter';
import { useTranslation } from 'react-i18next';

interface Props {
  value?: number;
  valueNT?: number;
  renderUnit?: () => JSX.Element;
}

const SelfReadingMeter = ({ value, valueNT, renderUnit }: Props) => {
  // translations
  const tLabels = useTranslation("contracts\\contracts").t;

  if (valueNT != null) {
    return (
      <div className="d-flex flex-wrap flex-sm-column">
        <span>
          <small className="mr-1 text-muted">
            {tLabels("selfReadingMeter.vT")}:
          </small>
          <span className="small">
            <NumberFormatter amount={value!} />
            {renderUnit && renderUnit()}
          </span>
        </span>
        <span className="ml-2 ml-sm-0 mt-lg-n1">
          <small className="mr-1 text-muted">
            {tLabels("selfReadingMeter.nT")}:
          </small>
          <span className="small">
            <NumberFormatter amount={valueNT} />
            {renderUnit && renderUnit()}
          </span>
        </span>
      </div>
    )
  } else {
    return (
      <>
        <NumberFormatter amount={value!} />
        {renderUnit && renderUnit()}
      </>
    )
  }
}

export default SelfReadingMeter;
